// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const DemoRentalHistoryFactoryCriteria = props =>
    <div className='demo-rental-factory-criteria'>
        <OptionsDropDown
            className='demo-rental-factory'
            isPlaceholderTranslated={false}
            label='FACTORY'
            onChange={props.onFactoryChange}
            optionDisplayAttributes={['key', 'value']}
            optionKey='key'
            options={props.factoryCodes}
            placeholder='SELECT_FACTORY'
            selectedValue={props.factory}
        />
    </div>;

DemoRentalHistoryFactoryCriteria.displayName = 'DemoRentalHistoryFactoryCriteria';
DemoRentalHistoryFactoryCriteria.propTypes = {
    factory: PropTypes.string.isRequired,
    factoryCodes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onFactoryChange: PropTypes.func.isRequired
};

export default DemoRentalHistoryFactoryCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-factory-criteria.js